import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link, Redirect } from 'react-router-dom';

import Files from 'react-files';

import { 
  loadAmenities,
  loadAmenity,
  addAmenity,
  editAmenity,
} from '../../reducers/amenities';

import update from 'immutability-helper';

import axios from 'axios';

class AmenityEditor extends Component {

  state = {
    id: null,
    mode: null,
    added: false,
    edited: false,
    permission: 'Allowed',
    amenity: {
      amenity: '',
      amenity_description: '',
    },
    amenityImageFile: null,
    amenityImageFileSrc: null,
    isEditingAmenityImage: false,
    errors: {
      amenity: null,
    },
    canAdd: false,
    canEdit: false,
  }

  componentDidMount = () => {

    window.scrollTo(0, 0);
    
    if (!isNaN(parseInt(this.props.match.params.id, 10))) {
      this.setState({mode: 'Edit', id: parseInt(this.props.match.params.id, 10)});
    } else {
      this.setState({mode: 'Add'});
    }

  }

  componentDidUpdate = (prevProps, prevState) => {
    if(this.state.mode === 'Add' && prevState.mode !== this.state.mode) {
    }
    if(this.state.mode === 'Edit' && prevState.mode !== this.state.mode) {
      this.loadAmenityByID();
    }
  }

  loadAmenityByID = () => {
    if(this.state.id){
      this.props.loadAmenity(this.state.id, (resp) => {
        if(resp.data) {
          this.setState({amenity: resp.data});
          this.mapAmenityToFields();
          this.validateFields();
        } else {
          this.setState({permission: 'Disallowed'});
        }
      });
    }
  }

  mapAmenityToFields = () => {
    this.mapAmenityImage();
  }

  mapAmenityImage = () => {
    if(this.state.amenity.amenity_image){
      axios.get(this.state.amenity.amenity_image).then((resp) => {
        const file = new File([resp.data], this.state.amenity.amenity_image.split('/').pop(), {type: "image/*"});
        this.setState({amenityImageFile: file, amenityImageFileSrc: this.state.amenity.amenity_image});
      });
    }
  }

  handleAmenityNameChange = (e) => {
    this.setState(update(this.state, {amenity: {amenity: {$set: e.target.value}}}), () => {

      if(this.state.amenity.amenity.length === 0) {
        this.setState(update(this.state, {errors: {amenity: {$set: 'Amenity name must not be empty'}}}));
      } else if( this.state.amenity.amenity.length > 0) {
        this.setState(update(this.state, {errors: {amenity: {$set: null}}}));
      }

      this.validateFields();
    });
  }

  handleAmenityDescriptionChange = (e) => {
    this.setState(update(this.state, {amenity: {amenity_description: {$set: e.target.value}}}), () => {
    });
  }

  handleAmenityImageChange = (file) => {
    if(file.length){
      this.setState({amenityImageFile: file[0]}, () => { } );
      const reader  = new FileReader();
  
      reader.onload = (e) => {
        this.setState({amenityImageFileSrc: e.target.result, isEditingAmenityImage: true});
      };
      reader.readAsDataURL(file[0]);
    }
  }

  handleAmenityImageChangeError = (error, file) => {
    window.alert(`${error.message}`);
  }

  removeAmenityImage = () => {
    this.setState({amenityImageFile: null, amenityImageFileSrc: null});
  }

  addAmenity = () => {
    
    const amenity = Object.assign({}, this.state.amenity);
    delete amenity.amenity_id;    
    amenity.amenity_name = amenity.amenity;
    amenity.is_active = 1;

    const data = new FormData()
    data.append('data', JSON.stringify(amenity));

    if(this.state.isEditingAmenityImage){
      data.append('file', this.state.amenityImageFile);
    }

    this.props.addAmenity(data, (resp) => {
      this.setState({added: true});
      this.props.loadAmenities();
    });
  }

  editAmenity = () => {
    
    const amenity = Object.assign({}, this.state.amenity);
    delete amenity.amenity_id;    
    amenity.amenity_name = amenity.amenity;
    amenity.is_active = 1;

    const data = new FormData()
    data.append('data', JSON.stringify(amenity));

    if(this.state.isEditingAmenityImage){
      data.append('file', this.state.amenityImageFile);
    }

    this.props.editAmenity(this.state.id, data, (resp) => {
      this.setState({edited: true});
      this.props.loadAmenities();
    });
  }

  validateFields = () => {
    let flag = true;

    if(this.state.amenity.amenity.length === 0) {
      flag = false;
    } else if( this.state.amenity.amenity.length > 0) {
    }

    if(flag) {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: true});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: true});
      }
    } else {
      if(this.state.mode === 'Add') {
        this.setState({canAdd: false});
      } else if (this.state.mode === 'Edit') {
        this.setState({canEdit: false});
      }
    }

  }

  render() {

    if (this.state.permission !== 'Allowed' || this.state.added || this.state.edited) {
      return <Redirect to='/amenities'/>;
    }

    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>{this.state.mode === 'Add' ? 'Add' : ''}{this.state.mode === 'Edit' ? 'Edit' : ''} Ameniy</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/amenities'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addAmenity} disabled={this.props.isAddingAmenity || !this.state.canAdd} >Add Amenity</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editAmenity} disabled={this.props.isEditingAmenity || !this.state.canEdit} >Edit Amenity</button>
                }
              </div>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <h3>Amenity Details</h3>
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="amenityName">Amenity Name *</label>
                    <input type="text" className="form-control" id="amenityName" value={this.state.amenity.amenity} onChange={this.handleAmenityNameChange} placeholder="Amenity Name" autoFocus />
                    {this.state.errors.amenity &&
                      <small id="amenityNameError" className="form-text text-muted">{this.state.errors.amenity}</small>
                    }
                  </div>
                  <div className="form-group">
                    <label htmlFor="amenityDescription">Amenity Description</label>
                    <textarea className="form-control" id="amenityDescription" rows="3" value={this.state.amenity.amenity_description} onChange={this.handleAmenityDescriptionChange} ></textarea>
                  </div>
                  <div className="form-group">
                    <label htmlFor="amenityImage">Amenity Image</label>
                    {this.state.amenityImageFile ? 
                      <div>
                        <div style={{backgroundImage: `url(${this.state.amenityImageFileSrc}), url('/trans.png')`, marginRight: '20px', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem', backgroundSize: 'contain, auto', backgroundRepeat: 'no-repeat, repeat', backgroundPosition: 'center', float: 'left'}}></div>
                        <div style={{float: 'left'}}>
                          {this.state.amenityImageFile.name} <br/>
                          {this.state.amenityImageFile.size} <br/>
                          {this.state.amenityImageFile.type} <br/>
                          <a className="btn btn-danger btn-sm" style={{color: 'white', marginTop: '10px'}} onClick={this.removeAmenityImage}>Remove</a>
                        </div>
                        <div style={{clear: 'both'}}></div>
                      </div>
                      :
                      <Files name="amenityImage" accepts={['image/*']} clickable className="field-drop inputClass" onError={this.handleAmenityImageChangeError} onChange={this.handleAmenityImageChange} maxFileSize={500000}  style={{display: 'block', height: '200px', width: '300px', border: 'solid 1px #ced4da', borderRadius: '.25rem'}} dropActiveClassName="dropping">
                        <div className="centered"><a className="btn btn-primary">Add Image</a></div>
                      </Files>
                    }
                    <small id="amenityImageError" className="form-text text-muted">Max file size 500kB.</small>
                  </div>
                </form>
              </div>
            </div>
          </div>


          <div className="container-fluid">
            <hr />
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">
              <div className="col-md-4 offset-md-8 text-right">
                <Link to='/amenities'><button className="btn btn-light" style={{marginRight: '10px'}}>Cancel</button></Link>
                {this.state.mode === 'Add' &&
                  <button className="btn btn-primary" onClick={this.addAmenity} disabled={this.props.isAddingAmenity || !this.state.canAdd} >Add Amenity</button>
                }
                {this.state.mode === 'Edit' &&
                  <button className="btn btn-primary" onClick={this.editAmenity} disabled={this.props.isEditingAmenity || !this.state.canEdit} >Edit Amenity</button>
                }
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  amenities: state.amenities.amenities,
  isLoadingAmenity: state.amenities.isLoadingAmenity,
  isAddingAmenity: state.amenities.isAddingAmenity,
  isEditingAmenity: state.amenities.isEditingAmenity,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadAmenity,
      loadAmenities,
      addAmenity,
      editAmenity,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AmenityEditor);


// WEBPACK FOOTER //
// ./src/modules/Amenities/AmenityEditor.js